export enum OrderStatusColor {
  Assigned = '#BDBDBD',
  Delivered = '#3CB371',
  NoAssigned = '#FE9A2E',
  OnDelivery = '#6495ED',
  Partial = '#FFCE00',
  Rejected = '#FE2E2E',
  Undelivered = '#DC143C'
}
